import { IconUsuarios } from "../../Icons/IconUsuarios";
import { IconContatos } from "../../Icons/IconContatos";
import { IconFolder } from "../../Icons/IconFolder";
import { IconMovimentos } from "../../Icons/IconMovimentos";
import { IconsNotaFiscal } from "../../Icons/IconsNotaFiscal";
import { IconTouro } from "../../Icons/IconTouro";
import { URLS } from "../../../infra/URLS";
import { IconInicio } from "../../Icons/IconInicio";
import { IconBotijao } from "../../Icons/IconBotijao";
import { IconAudit } from "../../Icons/IconAudit";

export const Menus = [
  {
    title: "Início",
    src: URLS.DASHBOARD,
    icon: <IconInicio width="25" height="25" />,
  },
  {
    title: "Clientes",
    src: URLS.CLIENTES,
    icon: <IconFolder width="25" height="25" />,
  },
  {
    title: "Contatos",
    src: URLS.CONTATOS,
    icon: <IconContatos width="25" height="25" />,
  },
  {
    title: "Movimentos",
    src: URLS.MOVIMENTOS,
    icon: <IconMovimentos width="25" height="25" />,
  },
  // {title: 'Ficheiro ABS', src: URLS.FICHEIRO_ABS, icon: <IconFicheiro width="25" height="25" />},
  {
    title: "Notas Fiscais",
    src: URLS.NOTAS_FISCAIS,
    icon: <IconsNotaFiscal width="25" height="25" />,
  },
  {
    title: "Produtos",
    src: URLS.PRODUTOS,
    icon: <IconTouro width="25" height="25" />,
  },
  {
    title: "Botijão",
    src: URLS.BOTIJAO,
    icon: <IconBotijao width="25" height="25" />,
  },
  {
    title: "Auditoria",
    src: URLS.AUDITORIA,
    icon: <IconAudit width="25" height="25" />,
  },
  {
    title: "Usuários",
    src: URLS.USUARIOS,
    icon: <IconUsuarios width="25" height="25" />,
  },
];
